export const SUPPORTED_FORMATS = ['JPG', 'JPEG', 'PNG', 'HEIC'];

export const MEGABYTE_IN_BYTE = 1 * 1024 * 1024;
